export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11952.56212a36.jpg";